function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "logo-red");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "logo-red",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Fade",
  transform: "translate(-0.750000, 1.000000)",
  fill: "#D32F2F"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("polygon", {
  id: "Rectangle-Copy-10",
  fillOpacity: 0.9,
  points: "31.2055664 0 34.2055664 0 33.7850098 3 30.7850098 3"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-20",
  fillOpacity: 0.7,
  points: "25.2055664 0 28.2055664 0 27.7850098 3 24.7850098 3"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-30",
  fillOpacity: 0.5,
  points: "19.2055664 0 22.2055664 0 21.7850098 3 18.7850098 3"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-40",
  fillOpacity: 0.3,
  points: "13.2055664 0 16.2055664 0 15.7850098 3 12.7850098 3"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-50",
  fillOpacity: 0.1,
  points: "7.20556641 0 10.2055664 0 9.78500977 3 6.78500977 3"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-5",
  points: "33.7850098 3 36.7850098 3 36.3644531 6 33.3644531 6"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-11",
  fillOpacity: 0.8,
  points: "27.7850098 3 30.7850098 3 30.3644531 6 27.3644531 6"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-21",
  fillOpacity: 0.6,
  points: "21.7850098 3 24.7850098 3 24.3644531 6 21.3644531 6"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-31",
  fillOpacity: 0.4,
  points: "15.7850098 3 18.7850098 3 18.3644531 6 15.3644531 6"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-41",
  fillOpacity: 0.2,
  points: "9.78500977 3 12.7850098 3 12.3644531 6 9.36445312 6"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-51",
  fillOpacity: 0,
  points: "3.78500977 3 6.78500977 3 6.36445312 6 3.36445313 6"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-12",
  fillOpacity: 0.9,
  points: "30.3644531 6 33.3644531 6 32.9438965 9 29.9438965 9"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-22",
  fillOpacity: 0.7,
  points: "24.3644531 6 27.3644531 6 26.9438965 9 23.9438965 9"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-32",
  fillOpacity: 0.5,
  points: "18.3644531 6 21.3644531 6 20.9438965 9 17.9438965 9"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-42",
  fillOpacity: 0.3,
  points: "12.3644531 6 15.3644531 6 14.9438965 9 11.9438965 9"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-52",
  fillOpacity: 0.1,
  points: "6.36445312 6 9.36445312 6 8.94389648 9 5.94389648 9"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-6",
  points: "32.9438965 9 35.9438965 9 35.5233398 12 32.5233398 12"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-13",
  fillOpacity: 0.8,
  points: "26.9438965 9 29.9438965 9 29.5233398 12 26.5233398 12"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-23",
  fillOpacity: 0.6,
  points: "20.9438965 9 23.9438965 9 23.5233398 12 20.5233398 12"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-33",
  fillOpacity: 0.4,
  points: "14.9438965 9 17.9438965 9 17.5233398 12 14.5233398 12"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-43",
  fillOpacity: 0.2,
  points: "8.94389648 9 11.9438965 9 11.5233398 12 8.52333984 12"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-53",
  fillOpacity: 0,
  points: "2.94389648 9 5.94389648 9 5.52333984 12 2.52333984 12"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-14",
  fillOpacity: 0.9,
  points: "29.5233398 12 32.5233398 12 32.1027832 15 29.1027832 15"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-24",
  fillOpacity: 0.7,
  points: "23.5233398 12 26.5233398 12 26.1027832 15 23.1027832 15"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-34",
  fillOpacity: 0.5,
  points: "17.5233398 12 20.5233398 12 20.1027832 15 17.1027832 15"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-44",
  fillOpacity: 0.3,
  points: "11.5233398 12 14.5233398 12 14.1027832 15 11.1027832 15"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-54",
  fillOpacity: 0.1,
  points: "5.52333984 12 8.52333984 12 8.1027832 15 5.1027832 15"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-7",
  points: "32.1027832 15 35.1027832 15 34.6822266 18 31.6822266 18"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-15",
  fillOpacity: 0.8,
  points: "26.1027832 15 29.1027832 15 28.6822266 18 25.6822266 18"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-25",
  fillOpacity: 0.6,
  points: "20.1027832 15 23.1027832 15 22.6822266 18 19.6822266 18"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-35",
  fillOpacity: 0.4,
  points: "14.1027832 15 17.1027832 15 16.6822266 18 13.6822266 18"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-45",
  fillOpacity: 0.2,
  points: "8.1027832 15 11.1027832 15 10.6822266 18 7.68222656 18"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-55",
  fillOpacity: 0,
  points: "2.1027832 15 5.1027832 15 4.68222656 18 1.68222656 18"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-16",
  fillOpacity: 0.9,
  points: "28.6822266 18 31.6822266 18 31.2616699 21 28.2616699 21"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-26",
  fillOpacity: 0.7,
  points: "22.6822266 18 25.6822266 18 25.2616699 21 22.2616699 21"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-36",
  fillOpacity: 0.5,
  points: "16.6822266 18 19.6822266 18 19.2616699 21 16.2616699 21"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-46",
  fillOpacity: 0.3,
  points: "10.6822266 18 13.6822266 18 13.2616699 21 10.2616699 21"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-56",
  fillOpacity: 0.1,
  points: "4.68222656 18 7.68222656 18 7.26166992 21 4.26166992 21"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-8",
  points: "31.2616699 21 34.2616699 21 33.8411133 24 30.8411133 24"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-17",
  fillOpacity: 0.8,
  points: "25.2616699 21 28.2616699 21 27.8411133 24 24.8411133 24"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-27",
  fillOpacity: 0.6,
  points: "19.2616699 21 22.2616699 21 21.8411133 24 18.8411133 24"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-37",
  fillOpacity: 0.4,
  points: "13.2616699 21 16.2616699 21 15.8411133 24 12.8411133 24"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-47",
  fillOpacity: 0.2,
  points: "7.26166992 21 10.2616699 21 9.84111328 24 6.84111328 24"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-57",
  fillOpacity: 0,
  points: "1.26166992 21 4.26166992 21 3.84111328 24 0.841113281 24"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-18",
  fillOpacity: 0.9,
  points: "27.8411133 24 30.8411133 24 30.4205566 27 27.4205566 27"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-28",
  fillOpacity: 0.7,
  points: "21.8411133 24 24.8411133 24 24.4205566 27 21.4205566 27"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-38",
  fillOpacity: 0.5,
  points: "15.8411133 24 18.8411133 24 18.4205566 27 15.4205566 27"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-48",
  fillOpacity: 0.3,
  points: "9.84111328 24 12.8411133 24 12.4205566 27 9.42055664 27"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-58",
  fillOpacity: 0.1,
  points: "3.84111328 24 6.84111328 24 6.42055664 27 3.42055664 27"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-9",
  points: "30.4205566 27 33.4205566 27 33 30 30 30"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-19",
  fillOpacity: 0.8,
  points: "24.4205566 27 27.4205566 27 27 30 24 30"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-29",
  fillOpacity: 0.6,
  points: "18.4205566 27 21.4205566 27 21 30 18 30"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-39",
  fillOpacity: 0.4,
  points: "12.4205566 27 15.4205566 27 15 30 12 30"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-49",
  fillOpacity: 0.2,
  points: "6.42055664 27 9.42055664 27 9 30 6 30"
}), React.createElement("polygon", {
  id: "Rectangle-Copy-59",
  fillOpacity: 0,
  points: "0.420556641 27 3.42055664 27 3 30 0 30"
}))), React.createElement("path", {
  d: "M36.0217191,25.0009155 C35.8564951,28.2725719 36.641062,30.1493619 38.1326016,31.0004658 L35.2,31 L35.6175566,28 L32.6705566,28 L33.0911133,25 Z M45.3469459,29.0978753 L45.0025566,30.9995257 L43.064152,31.0010348 C43.87919,30.6151853 44.6047454,30.0395727 45.1885733,29.3056361 L45.3469459,29.0978753 Z M195.2,1 L195.198557,1.009 L203.673181,1.00998782 L202.27621,10.6633374 L196.155967,10.6633374 L196.76406,6.46129111 L194.711307,6.46129111 L193.85669,12.3668697 L199.976933,12.3668697 L199.182577,17.8560292 L193.062334,17.8560292 L191.950235,25.5408526 L194.002988,25.5408526 L194.879519,19.483849 L200.999762,19.483849 L199.334353,30.9921559 L191.016557,30.992 L191.016285,31 L188.211557,30.9995257 L189,25.3573972 L187.422244,25.3573972 L188.327249,1.00130622 L176.952729,1.00130622 L171.167688,25.3573972 L169.589932,25.3573972 L168.801557,30.9995257 L168.324557,30.9995257 L169.112936,25.3573972 L167.278336,25.3573972 L169.890513,6.64525265 L171.725113,6.64525265 L172.512997,1.00130622 L161.762241,1.00130622 L160.974357,6.64525265 L162.845649,6.64525265 L160.233472,25.3573972 L158.36218,25.3573972 L157.573557,30.9995257 L157.096557,30.9995257 L157.885184,25.3573972 L156.197352,25.3573972 L156.77901,21.1907253 L156.812765,20.9333668 C157.227815,17.5441945 156.236671,15.8442663 153.153278,15.6225366 L153.153278,15.6225366 L153.17443,15.4710212 L153.416939,15.4334739 C156.065195,14.975123 158.066079,13.0222659 158.527985,9.71343829 L158.527985,9.71343829 L158.75536,8.08464838 L158.788841,7.82995165 C159.368491,3.12186811 157.40233,1.00130622 151.598557,1.00130622 L151.598557,1.00130622 L141.434872,1.00130622 L140.646989,6.64525265 L142.444897,6.64525265 L139.832719,25.3573972 L138.034811,25.3573972 L137.246557,30.9995257 L132.219557,30.9995257 L133.008007,25.3573972 L130.989947,25.3573972 L133.644427,6.34222197 L134.818571,6.34222197 L133.961946,12.4785932 L139.208902,12.4785932 L140.811108,1.00130622 L121.180888,1.00130622 L119.578682,12.4785932 L124.825638,12.4785932 L125.682263,6.34222197 L126.856407,6.34222197 L124.201927,25.3573972 L122.183867,25.3573972 L121.395557,30.9995257 L118.423557,30.9995257 L119.211815,25.3573972 L117.634059,25.3573972 L118.539064,1.00130622 L107.164544,1.00130622 L101.379503,25.3573972 L99.8017467,25.3573972 L99.0135566,30.9995257 L98.5365566,30.9995257 L99.3247507,25.3573972 L97.5268426,25.3573972 L100.13902,6.64525265 L101.936928,6.64525265 L102.724812,1.00130622 L89.5523837,1.00130622 L85.5539043,21.7589078 L85.3337523,21.7589078 L87.2407876,1.00130622 L74.2518194,1.00130622 L73.4639359,6.64525265 L75.2618439,6.64525265 L72.6496663,25.3573972 L70.8517582,25.3573972 L70.0635566,30.9995257 L69.1095566,30.9995257 L70.7173766,19.4861777 L64.8099645,19.4861777 L63.9639151,25.5467913 L61.982547,25.5467913 L63.0559723,17.8573878 L68.9633844,17.8573878 L69.7301167,12.3649567 L63.8227046,12.3649567 L64.6476028,6.45585847 L66.6289708,6.45585847 L66.042024,10.6604092 L71.9494361,10.6604092 L73.2978274,1.00130622 L56.5662752,1.00130622 L55.7783916,6.64525265 L57.5762996,6.64525265 L54.964122,25.3573972 L53.166214,25.3573972 L52.3775566,30.9995257 L51.0935566,30.9995257 L53.346717,14.8649599 L45.4579369,14.8649599 L44.6753412,20.4710274 L45.9595612,20.4710274 L45.38319,25.1584765 L44.46589,25.1584765 L44.3359514,25.1558632 C43.5017588,25.1207359 43.3037219,24.7258563 43.433249,23.6320346 L43.433249,23.6320346 L45.4806629,7.86637214 L45.5088835,7.68021661 C45.6958181,6.54525308 46.0437705,6.23758231 46.8454908,6.23758231 L46.8454908,6.23758231 L47.5793308,6.23758231 L46.8293432,12.1376837 L53.7274393,12.1376837 L54.308217,7.44970572 L54.3418998,7.18436331 C54.7147639,3.91565329 53.3653973,1.88480862 50.909397,0.999167947 L195.2,1 Z M81.2942274,7.32707168 L79.6035566,30.9995257 L77.7315566,30.9995257 L81.0373834,7.32707168 L81.2942274,7.32707168 Z M93.17186,7.40282935 L89.8765566,30.9995257 L87.9695566,30.9995257 L92.915016,7.40282935 L93.17186,7.40282935 Z M110.738867,22.9710306 L110.167557,30.9995257 L106.571557,30.9995257 L108.280503,22.9710306 L110.738867,22.9710306 Z M148.583412,19.1831471 L148.705454,19.184294 C149.725864,19.2046585 149.785504,19.5086245 149.56655,21.0770888 L149.56655,21.0770888 L148.180557,30.9995257 L146.162557,30.9995257 L147.81288,19.1831471 L148.583412,19.1831471 Z M180.527052,22.9710306 L179.955557,30.9995257 L176.360557,30.9995257 L178.068688,22.9710306 L180.527052,22.9710306 Z M36.3455566,21.9995257 L33.5116699,22 L33.9322266,19 L36.7305566,18.9995257 L36.3455566,21.9995257 Z M111.911219,7.21343517 L111.196522,17.3270841 L109.398614,17.3270841 L111.580991,7.21343517 L111.911219,7.21343517 Z M181.699404,7.21343517 L180.984707,17.3270841 L179.186799,17.3270841 L181.369176,7.21343517 L181.699404,7.21343517 Z M37.1165566,15.9995257 L34.3527832,16 L34.7733398,13 L37.5015566,12.9995257 L37.1165566,15.9995257 Z M150.51746,6.3801008 C151.535264,6.3801008 151.684771,6.58804057 151.538508,7.7332161 L151.538508,7.7332161 L150.908685,12.2513202 L150.884538,12.4178788 C150.706866,13.5931905 150.504141,13.7664736 149.486337,13.7664736 L149.486337,13.7664736 L148.569037,13.7664736 L149.60016,6.3801008 Z M38.4773513,6.99899003 C38.2538504,7.75723647 38.0781918,8.58818055 37.9515791,9.49516197 L37.9515791,9.49516197 L37.8865566,9.99952565 L35.1938965,10 L35.6144531,7 Z M43.8707756,0.999987328 C41.3700042,1.81045242 39.5857737,3.60135195 38.600817,6.60227067 L38.9655566,4 L36.0350098,4 L36.4555664,1 Z",
  id: "Combined-Shape",
  fill: "#D32F2F"
}), React.createElement("path", {
  d: "M220.293811,11.4583191 L221.805827,1.00998782 L204.661543,1.00998782 L203.845274,6.65057247 L205.707956,6.65057247 L203.001668,25.3515713 L201.138985,25.3515713 L200.322716,30.9921559 L211.498812,30.9921559 L212.315081,25.3515713 L210.300343,25.3515713 L211.270005,18.651011 L217.276206,18.651011 L218.097954,12.97257 L212.091752,12.97257 L213.034023,6.46129111 L215.010748,6.46129111 L214.28761,11.4583191 L220.293811,11.4583191 Z M238.084332,11.4583191 L239.596347,1.00998782 L222.452063,1.00998782 L221.635794,6.65057247 L223.498477,6.65057247 L220.792188,25.3515713 L218.929505,25.3515713 L218.113236,30.9921559 L229.289332,30.9921559 L230.105602,25.3515713 L228.090863,25.3515713 L229.060525,18.651011 L235.066727,18.651011 L235.888474,12.97257 L229.882273,12.97257 L230.824544,6.46129111 L232.801268,6.46129111 L232.07813,11.4583191 L238.084332,11.4583191 Z M253.23811,30.9921559 L254.903519,19.483849 L248.783275,19.483849 L247.906745,25.5408526 L245.853992,25.5408526 L246.966091,17.8560292 L253.086334,17.8560292 L253.88069,12.3668697 L247.760447,12.3668697 L248.615064,6.46129111 L250.667817,6.46129111 L250.059723,10.6633374 L256.179967,10.6633374 L257.576937,1.00998782 L240.242584,1.00998782 L239.426315,6.65057247 L241.288997,6.65057247 L238.582709,25.3515713 L236.720026,25.3515713 L235.903757,30.9921559 L253.23811,30.9921559 Z M272.106522,24.5944458 L272.972096,18.6131547 L265.787463,18.6131547 L264.752061,25.7679903 L264.029796,25.7679903 C263.199192,25.7679903 262.957062,25.494668 263.094623,24.363797 L265.486101,7.82411693 C265.666885,6.57485993 265.982287,6.23415347 266.856608,6.23415347 L267.578873,6.23415347 L266.724255,12.139732 L273.908888,12.139732 L274.5882,7.4455542 C275.272989,2.7135201 272.250984,0.48 267.499242,0.48 C262.06325,0.48 258.606118,3.09208283 257.680282,9.48979294 L255.790263,22.5502071 C254.869905,28.9100609 257.565552,31.56 263.001544,31.56 C267.753286,31.56 271.427211,29.2886236 272.106522,24.5944458 Z M294.919302,12.4804385 L296.579233,1.00998782 L276.241778,1.00998782 L274.581848,12.4804385 L280.017841,12.4804385 L280.905328,6.34772229 L282.121774,6.34772229 L279.371659,25.3515713 L277.280892,25.3515713 L276.464623,30.9921559 L287.678733,30.9921559 L288.495003,25.3515713 L286.404236,25.3515713 L289.154352,6.34772229 L290.370797,6.34772229 L289.48331,12.4804385 L294.919302,12.4804385 Z M295.851729,30.9921559 L296.804956,24.4051644 L290.494643,24.4051644 L289.541416,30.9921559 L295.851729,30.9921559 Z M315.923086,30.9921559 L316.701007,25.6165652 L315.066407,25.6165652 L316.874252,13.1239951 C317.482345,8.92194884 316.192546,6.80199756 313.189445,6.80199756 C311.098679,6.80199756 309.478843,8.01339829 308.27068,10.057637 L308.697989,7.10484775 L300.10684,7.10484775 L299.328919,12.4804385 L300.963518,12.4804385 L299.062542,25.6165652 L297.427943,25.6165652 L296.650022,30.9921559 L305.317198,30.9921559 L307.897486,13.1618514 L308.847834,13.1618514 C309.646127,13.1618514 309.765312,13.388989 309.622876,14.3732521 L307.217895,30.9921559 L315.923086,30.9921559 Z M333.613734,24.064458 L333.893128,22.1337881 L326.822537,22.1337881 L326.203487,26.4115469 L325.291153,26.4115469 C324.644916,26.4115469 324.33566,26.1844093 324.483575,25.1622899 L325.11906,20.7709622 L334.090348,20.7709622 L335.076445,13.9568331 C335.766713,9.18694275 333.516277,6.6127162 328.23234,6.6127162 C322.796348,6.6127162 319.762847,9.18694275 318.919186,15.0168088 L317.741348,23.1559074 C316.903165,28.9479172 319.229629,31.5221437 324.589594,31.5221437 C329.949558,31.5221437 332.874161,29.1750548 333.613734,24.064458 Z M327.840167,16.152497 L325.787414,16.152497 L326.269506,12.8211449 C326.417421,11.7990256 326.792416,11.5718879 327.324611,11.5718879 L327.590709,11.5718879 C328.160918,11.5718879 328.470173,11.7990256 328.322259,12.8211449 L327.840167,16.152497 Z M362.888214,12.4804385 L363.666135,7.10484775 L356.481502,7.10484775 L353.229258,23.7994641 L353.001174,23.7994641 L354.504778,7.10484775 L346.065685,7.10484775 L342.699398,23.7994641 L342.509329,23.7994641 L344.050946,7.10484775 L336.524187,7.10484775 L335.746266,12.4804385 L337.266824,12.4804385 L335.994442,30.9921559 L345.687995,30.9921559 L349.021746,14.2596833 L349.135787,14.2596833 L347.626706,30.9921559 L357.282244,30.9921559 L361.367657,12.4804385 L362.888214,12.4804385 Z M377.215715,24.064458 L377.182845,24.2915956 C376.443272,29.4021924 372.937838,31.56 368.148082,31.56 C363.510383,31.56 360.895574,29.4021924 361.498189,25.2380024 L361.799496,23.1559074 L368.41392,23.1559074 L367.882524,26.8279659 L368.9089,26.8279659 C369.517123,26.8279659 369.859583,26.562972 369.974627,25.7679903 L370.073237,25.0865773 L370.109788,24.7985381 C370.258797,23.383636 369.755561,23.0549574 366.982353,21.4902314 C364.14493,19.868389 362.506882,18.4259968 362.999143,14.3674087 L363.076613,13.805408 C363.810707,8.73266748 367.310663,6.6127162 372.062405,6.6127162 C376.738119,6.6127162 379.352927,8.77052375 378.755791,12.8968575 L378.449005,15.0168088 L371.834581,15.0168088 L372.365977,11.3447503 L371.301587,11.3447503 C370.693364,11.3447503 370.350905,11.6097442 370.23586,12.4047259 L370.148207,13.0104263 C369.936379,14.4742022 370.237602,14.8270407 372.313508,16.04719 L373.277104,16.6067722 C376.191215,18.2724482 377.840243,19.7488429 377.215715,24.064458 Z",
  id: "FFECT.news",
  fill: "#D32F2F",
  fillRule: "nonzero"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "190px",
    height: "16px",
    viewBox: "0 0 380 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.2fb0e561.svg";
export { ForwardRef as ReactComponent };